import { render, staticRenderFns } from "./MyDetails.vue?vue&type=template&id=824304ce&scoped=true&"
import script from "./MyDetails.vue?vue&type=script&lang=js&"
export * from "./MyDetails.vue?vue&type=script&lang=js&"
import style0 from "./MyDetails.vue?vue&type=style&index=0&id=824304ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "824304ce",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VCol,VRow,VTextField})
